import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class TLReviewStepService extends StepBaseService {
  // @ts-ignore
  getExtensionKey = () => {
    return StepBusinessType.tLReview;
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getProcedureFileStepKey = () => {
    return StepBusinessType.procedureFile;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}
const service = new TLReviewStepService();
export default service;
